export default {
  base_account_url: '//instagram.com/',
  tiktok_base_account_url: '//tiktok.com/',
  base_hashtag_url: '//instagram.com/explore/tags/',
}
